import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import Login from './Login'
import './ProtectedRoute.css'

interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, fallback }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-container">
        Loading...
      </div>
    )
  }

  if (!user) {
    return <>{fallback || <Login />}</>
  }

  return <>{children}</>
}

export default ProtectedRoute
